<!-- Footer -->
<section class="flex flex-col justify-center w-full bg-white">
    <div class="">
        <div class="text-gray-800 sm:grid md:grid-cols-3 sm:grid-cols-2 mx-auto">
            <div class="p-5">
                <div class="flex flex-col items-center">
                    <a class="flex justify-center mb-5" [routerLink]="view.site?.website">
                        @if(view.site?.logoUrl) {
                        <img [alt]="view.site?.name" [src]="view.site?.logoUrl" [style.max-width]="(view.site?.id === 88 || view.site?.id === 96) ? '40%' : '65%'">
                        }
                    </a>
                    @if(view.site?.slogan) {
                    <p class="py-5 ml-1 text-primary-500 dark:text-white text-center text-2xl font-semibold">
                        {{view.site?.slogan}}
                    </p>
                    }
                </div>
            </div>
            <div class="p-5">
                <div class="text-3xl font-semibold font-primary tracking-wide mb-2">Destinations</div>
                <div class="flex flex-col">
                    @if(view.destinations) {
                    @for(item of view.destinations; track item) {
                    <ul class="mt-3">
                        <li
                            class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500 dark:text-white">
                            <a class="cursor-pointer" [routerLink]="['/destination', item.id, item.seo.alias]">{{
                                item.name }}</a>
                        </li>
                    </ul>
                    }
                    }
                </div>
            </div>
           
            <div class="p-5">
                <div class="text-3xl font-semibold font-primary tracking-wide mb-2">Contact</div>
                <div class="flex flex-col">
                    @if(view.site?.telephone) {
                    <ul class="mt-2">
                        <li class="mb-4 flex items-center group">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:local_phone'"></mat-icon>
                            </div>
                            <div>
                                <p class="text-gray-600 dark:text-white">{{view.site?.telephone}}</p>
                            </div>
                        </li>
                    </ul>
                    }
                    @if(view.site?.emailAddress) {
                    <ul class="mt-2">
                        <li class="mb-4 flex items-center group transform transition-transform duration-300 hover:translate-x-2">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:email'"></mat-icon>
                            </div>
                            <a [href]="'mailto:' + view.site?.emailAddress"
                                class="text-gray-600 dark:text-white hover:text-primary-500">
                                {{view.site?.emailAddress}}
                            </a>
                        </li>
                    </ul>
                    }
                    @if(view.site?.address) {
                    <ul class="mt-3">
                        <li class="mb-4 flex items-center group">
                            <div class="flex items-center justify-center w-6 h-6 bg-primary-500 rounded-md mr-3">
                                <mat-icon class="icon-size-4 text-white" [svgIcon]="'mat_solid:location_on'"></mat-icon>
                            </div>
                            <div>
                                <p class="text-gray-600 dark:text-white">{{view.site.address}}</p>
                            </div>
                        </li>
                    </ul>
                    }
                </div>
            </div>
        </div>
    </div>


    <div class="flex flex-col items-center">
        <!-- Socials Wrapper -->
        <div class="flex flex-col md:flex-row justify-center items-center max-w-screen-lg w-full px-3 py-3">
    
            <!-- First set of socials -->
            <div class="flex flex-row items-center mt-2">
                <h1>Sandown Travel</h1>
                @if(view.site?.socialUrlFacebook) {
                <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                    class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                        [svgIcon]="'feather:facebook'"></mat-icon>
                </a>
                }
                @if(view.site?.socialUrlInstagram) {
                <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                    class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                        [svgIcon]="'feather:instagram'"></mat-icon>
                </a>
                }
                @if(view.site?.socialUrlTwitter) {
                <a href="{{view.site?.socialUrlTwitter}}" target="_blank"
                    class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                        [svgIcon]="'feather:twitter'"></mat-icon>
                </a>
                }
                @if(view.site?.socialUrlLinkedIn) {
                <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                    class="group relative w-8 h-8 ml-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                        [svgIcon]="'feather:linkedin'"></mat-icon>
                </a>
                }
                @if(view.site?.socialUrlYouTube) {
                <a href="{{view.site?.socialUrlYouTube}}" target="_blank"
                    class="group relative w-8 h-8 ml-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <img src="/assets/icons/xlgo-1.png" alt="">
                </a>
                }
            </div>
    
            <!-- Special socials for Sandown -->
            @if(view.site && view.site.id === 99 ) {
            <div class="flex items-center mt-2">
                <h1 class="mx-5">|</h1>
                <a href="https://www.facebook.com/CruiseCorner/" target="_blank"
                    class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                        [svgIcon]="'feather:facebook'"></mat-icon>
                </a>
                <a href="https://www.instagram.com/cruise_corner/" target="_blank"
                    class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                    <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                        [svgIcon]="'feather:instagram'"></mat-icon>
                </a>
                <h1>Cruise Corner</h1>
            </div>
            }
        </div>
    
        <!-- Copyright -->
        <div class="w-full py-7 border-t">
            <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row px-15">
                <p class="text-sm text-center text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}} <span class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.</p>
                
                @if(view.pages) {
                    <ul class="flex items-center gap-9 mt-4 lg:mt-0">
                    @for(page of view.pages; track page) {
                    <li><a [routerLink]="['/policy', page.seo.alias]" class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a></li>
                    }
                   
                    @if(view.site?.id === 99) {
                        <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/sandown-booking-form.pdf'"
                                target="_blank"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Download Booking Form</a></li>
                        <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/sandown-terms-conditions.pdf'"
                                target="_blank"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Terms & Conditions</a></li>
                        }
                    </ul>
                }
            </div>
        </div>
    </div>
      
</section>